import React from "react";
import { useTranslation } from "react-i18next";
import getAvatarUrl from "../../../../utils/get-avatar-url";
import { truncateText } from "../../../../utils/string-helpers";
import PropTypes from "prop-types";

export const ParticipantCard = React.memo(
  ({ participant, handleParticipantAction, webAppTheme }) => {
    const { t } = useTranslation("coaching-portal");
    const {
      _id,
      name = "",
      avatar = {},
      role,
      isGuest,
      isBlocked,
      isRegistered,
    } = participant;
    return (
      <div className="edit-channel-cards" key={_id}>
        <div className="edit-channels-info-container">
          <div
            className={"avatar-group-chat avatar-group-chat-border"}
            style={{
              background: `url(${getAvatarUrl(
                { avatar },
                false,
                webAppTheme
              )})`,
              backgroundPosition: "center center",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
            }}
          ></div>
          <div className="identifier-group-chat">
            <span className="name-group-chat">{truncateText(name)}</span>
            <span className="role-group-chat">{role}</span>
          </div>
        </div>
        {role === "Client" && (
          <div className="make-block-actions">
            <button
              disabled={isBlocked || !isRegistered}
              type="button"
              className={
                isGuest
                  ? "admin-button-actions"
                  : "admin-button-actions admin-button-actions-danger"
              }
              onClick={() =>
                handleParticipantAction(
                  isGuest ? "make-admin" : "revoke-admin",
                  _id
                )
              }
            >
              {isGuest ? t("communityChat.makeGroupAdmin") : t("communityChat.revokeGroupAdmin")}
            </button>

            <button
              disabled={!isGuest}
              className={
                isBlocked
                  ? "block-button-actions"
                  : "block-button-actions admin-button-actions-danger"
              }
              onClick={() =>
                handleParticipantAction(
                  isBlocked ? "unblock-participant" : "block-participant",
                  _id
                )
              }
              type="button"
            >
              <span>{isBlocked ? t("communityChat.unblock") : t("communityChat.block")}</span>
            </button>
          </div>
        )}
      </div>
    );
  }
);

ParticipantCard.propTypes = {
  participant: PropTypes.object,
  handleParticipantAction: PropTypes.func,
  webAppTheme: PropTypes.string,
};
